import { ProgramDetailsContextProvider } from './context/ProgramDetailsContext';
import { ProgramDetailsLayout } from './layouts';

export const ProgramDetailsPage = () => {
  return (
    <ProgramDetailsContextProvider>
      <ProgramDetailsLayout />
    </ProgramDetailsContextProvider>
  );
};
